import { useQuery } from 'react-query';
import { useState } from 'react';

const useCurrentUser = (requestParams, appointment_id) => {
  const userObject =
    JSON.parse(localStorage.getItem('DQPN_AUTH')) || JSON.parse(sessionStorage.getItem('DQPN_AUTH')) || undefined;

  return {
    token: userObject ? userObject.auth_token : undefined,
    userID: userObject ? userObject.user_id : undefined,
    partnerUserId: userObject ? userObject.partnerUserId : undefined,
    partnerID: userObject ? userObject.partner_id : undefined,
    intercomUserHash: userObject && userObject.user ? userObject.user.intercom_user_hash : undefined,
    intercomUserId: userObject && userObject.user ? userObject.user.intercom_user_id : undefined,
  };
  /*
  const result = useQuery('current_user', () => postUserAuth(requestParams), {
    refetchOnWindowFocus: false,
    refetchInterval: 50000,
  });
  return result.data;*/
};

export default useCurrentUser;
